import CircularProgress from '@mui/material/CircularProgress';
import type { FC } from 'react';

/**
 * Centered spinning loader matching WarrQueue's CircularProgress style.
 * Used for full-content loading states (e.g. ticket details, popups).
 */
const CircleLoader: FC = () => <CircularProgress color="primary" size={60} />;

export default CircleLoader;
